export const ANALYSIS_VERSION = 1
